<template>
    <base-dialog close-on-back max-width="80vw" ref="base">
        <div style="background-color: #2a2a2a; color: #f2f2f2">
            <v-img max-height="80vh" contain :src="src">
            </v-img>
            <v-container style="background: #222222" fluid class="pa-3 caption">
                <v-row justify="end" no-gutters style="gap: 12px">
                    <v-col cols="auto" class="text-left">
                        <a :href="src"
                           style="color: white; text-decoration: unset"
                           target="_blank">
                            Открыть оригинал
                        </a>
                    </v-col>
                    <v-col cols="auto">
                         ·
                    </v-col>
                    <v-col class="d-flex align-center" style="gap: 4px" cols="auto">
                        <v-progress-circular
                            v-if="loadingSearch"
                            size="11" width="1"
                            indeterminate color="white"
                        />
                        <a @click="onSearchSimilar" class="white--text">
                            Найти похожие
                        </a>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </base-dialog>
</template>

<script>
import BaseDialog from "./BaseDialog";
import EventBus from "../../event-bus";
import { mapActions } from "vuex";

export default {
    name: "ImageDialog",
    components: {BaseDialog},
    data() {
        return {
            src: '',
            base64: '',

            loadingSearch: false,
        }
    },
    computed: {
        search_image: {
            get() {
                return this.$store.state.products.search_image;
            },
            set(value) {
                this.$store.state.products.search_image = value;
            }
        },
    },
    methods: {
        ...mapActions('products', [
            'searchByImageProducts',
        ]),
        async downloadImage(imageUrl) {
            const blob = await fetch(imageUrl).then(r => r.blob());
            return new File([blob], 'product.jpeg', {type: 'image/jpeg', lastModified: Date.now()});
        },
        async onSearchSimilar() {
            this.loadingSearch = true;
            this.search_image = await this.downloadImage(this.src);
            this.searchByImageProducts();
            this.$router.push({name: 'search_by_image'}).catch(() => {})
        },
    },
    mounted() {
        const vm = this;
        EventBus.$on('image_dialog', function (src) {
            vm.src = src;
            vm.loadingSearch = false;
            if (vm.$refs.base) {
                vm.$refs.base.show();
            }
        })
    }
}
</script>

<style scoped>
</style>